export const EnumPaymentStatus = {
	NONE: "none",
	WAITING: "waiting",
	PENDING: "pending",
	SUCCESS: "success",
	FAILURE: "failure",
};
